// extracted by mini-css-extract-plugin
export default {"description":"style_description__LItVG","fade-in":"style_fade-in__jTqat","top":"style_top__URbPf","image":"style_image__yk2HX"};